interface AudioPausedNoticeProps {
  readonly onResume: () => void
}

/**
 * Shown when the browser paused the audio without breaking anything.
 *
 * A button rather than a message, because the fix is a tap: after a call or
 * Siri, iOS only resumes an AudioContext that a user gesture asked for. It is
 * also the reason the meters went blank, which is worth saying out loud —
 * frozen needles that look like readings are worse than none.
 */
export function AudioPausedNotice({ onResume }: AudioPausedNoticeProps): React.JSX.Element {
  return (
    <button type="button" className="notice notice--paused" onClick={onResume}>
      <span className="notice__message">Audio pausiert — tippen zum Fortsetzen</span>
      <span className="notice__hint">
        Ein Anruf, Siri oder eine andere App hat das Mikrofon unterbrochen. Die Messung ruht so
        lange.
      </span>
    </button>
  )
}
